sn-banner-type-1 {
  // Was `.me-container` — popup-banner-type-2 now renders its own container div, so this
  // has to follow the rename or the strip silently gains its vertical padding back.
  .popup-banner-type-2__container {
    padding-top: 0;
    padding-bottom: 0;
  }
}
